<ekp-checkbox #checkbox [checked]="checked" [label]="label"></ekp-checkbox>
